import React from 'react'
import classes from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Mask from '../../../../components/alert/mask';
import { BigButton } from '../../../../components/button';
import { FormattedMessage } from 'react-intl';

const PointsReminderModal = props => {
    useStyles(classes)
    const {reminderMessage, onClose} = props

    return (
        <React.Fragment>
            <div className={classes.ModalContainer}>
                <div className={classes.Container}>
                    <div dangerouslySetInnerHTML={{__html: reminderMessage}}></div>

                    <BigButton className={classes.ModalBtn} onClick={() => onClose()}>
                        <FormattedMessage id={'ok'} defaultMessage={'OK'}/>
                    </BigButton>
                </div>
            </div>
            <Mask onClick={() => onClose()}/>
        </React.Fragment>
    )
}

export default PointsReminderModal